<template>
    <div>
        <BlockCategorySearchBoxDropdown :type='type' />
        <BlockFilter :productType='type' />
        <BlockItemListing :type="type" />
    </div>
</template>

<script>
    import BlockCategorySearchBoxDropdown from './BlockCategorySearchBoxDropdown.vue';
    import BlockFilter from './BlockFilter.vue';
    import BlockItemListing from './BlockItemListing.vue';

    export default {
        components: {
			BlockItemListing,
            BlockCategorySearchBoxDropdown,
            BlockFilter
		},
		created() {
			this.checkType();
		},
		methods: {
        	checkType() {
        		const url = window.location.href;
				if(url.includes('/packages/')) {
					this.type = 'package';
				} else {
					this.type = 'regular';
				}
			}
		},
		data() {
			return {
				type: ''
			};
		}
    };
</script>

<style lang="scss" scoped>

</style>
